import organizationPupilRepository from '@app/api/repositories/organization-pupil-repository'
import pupilsRepository from '@app/api/repositories/pupils-repository'
import { AUTHORITIES } from '@app/constants/authorities'
import { host_without_last_slash } from '@app/constants/env'
import { IPathParams } from '@app/constants/path-params'
import useBoolean from '@app/hooks/useBoolean'
import { IFile } from '@app/interfaces/files'
import { IOrganizationPupils } from '@app/interfaces/pupil/organization-pupils'
import AvatarForm from '@app/pages/pupils-page/components/pupil-page/components/avatar-form'
import RemoveAvatarForm from '@app/pages/pupils-page/components/pupil-page/components/remove-avatar-form'
import Loader from '@app/shared/loader/loader'
import ThreeDots from '@app/shared/loader/ThreeDots'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import { updateOrganizationPupilPaymentType } from '@app/store/actions/organization-pupils-actions'
import { useGetPupilBillingQuery } from '@app/store/rtk/api/billing/pupil-billing'
import { useGetPupilPaymentTypesQuery } from '@app/store/rtk/api/pupil-payment-types-api'
import { formatTiyinToSumLabel } from '@app/utils/format-tiyin-to-sum-label'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { Card, Checkbox, Descriptions, Form, Image, Radio, Spin } from 'antd'
import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { useParams } from 'react-router-dom'

interface props {
  _pupil: IOrganizationPupils
  preload: IFile
  avatar: IFile
}

const OrganizationPupilInfo: React.FC<props> = ({
  _pupil,
  avatar,
  preload,
}) => {
  const dispatch = useDispatch()
  const params: IPathParams = useParams()
  const [t] = useTranslation()
  const location = useLocation()
  const { data: paymentTypes } = useGetPupilPaymentTypesQuery('')
  const { data: pupilBillingData } = useGetPupilBillingQuery(_pupil?.pupil?.id)
  const { pupil } = (location.state as { pupil: IOrganizationPupils }) || {}
  const changeGovernmentStakeLoading = useBoolean()
  const [governmentStake, setGovernmentStake] = useState<boolean>(
    !!_pupil?.governmentStake,
  )
  const [paymentPercentage, setPaymentPercentage] = useState<number>(
    _pupil?.pupil?.pupilPaymentType?.id ?? 3,
  )
  const changePercentageLoading = useBoolean()

  const organizationId = Number(params.id)
  const pupilGroupId = _pupil?.educationGroup.id

  const toggleGovernmentStake = (e) => {
    changeGovernmentStakeLoading.setTrue()
    organizationPupilRepository
      .toggleGovernmentStake({
        id: _pupil.id,
        governmentStake: e.target.checked,
      })
      .then(() => {
        openNotificationWithIcon('success', t('pupils.governmentStakeSuccess'))
        setGovernmentStake((prev) => !prev)
        changeGovernmentStakeLoading.setFalse()
      })
      .catch(() => {
        changeGovernmentStakeLoading.setFalse()
      })
  }

  const changePaymentPercentage = (e) => {
    changePercentageLoading.setTrue()
    pupilsRepository
      .updatePaymentPercentage({
        id: _pupil.pupilId,
        paymentTypeId: e.target.value,
      })
      .then(() => {
        openNotificationWithIcon(
          'success',
          t('pupils.paymentPercentageSuccess'),
        )
        setPaymentPercentage(e.target.value)
        dispatch(
          updateOrganizationPupilPaymentType(
            +e.target.value,
            paymentTypes?.response?.find((i) => i.id === +e.target.value)
              ?.value ?? 0,
          ),
        )
        changePercentageLoading.setFalse()
      })
      .catch(() => {
        changePercentageLoading.setFalse()
      })
  }

  console.log('_pupil on info page: ', _pupil)

  const newMenu = (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
      }}>
      <AvatarForm
        pupil={_pupil.pupil}
        avatar={preload}
        edit={_pupil?.pupil?.fileId ? true : false}
        additionalValues={{
          organizationId,
          groupId: pupilGroupId,
        }}
      />
      {_pupil?.pupil?.fileId && (
        <RemoveAvatarForm
          pupil={_pupil.pupil}
          avatar={preload}
          additionalValues={{
            organizationId,
            groupId: pupilGroupId,
          }}
        />
      )}
    </div>
  )

  return (
    <div>
      {!isEmpty(_pupil) || !isEmpty(pupil) ? (
        <Card
          extra={
            <>
              <p>
                <span>{t('pupils.billing.balance')}:</span>
                <span>
                  {formatTiyinToSumLabel(
                    pupilBillingData?.response?.currentBalance ?? 0,
                  )}
                </span>
              </p>
              {/* <Link
                to={`/organization/${params.id}/pupils`}
                className={'ant-btn ant-btn-default institution_edit'}
                type={'primary'}>
                {t('general.back')}
              </Link> */}
            </>
          }
          title={`${_pupil?.pupil?.fullName ?? pupil?.pupil.fullName ?? ''}`}>
          <div className="avatar">
            <p>{t('users.avatar')}</p>
            {avatar.id && _pupil.pupil?.fileId ? (
              <Image
                width={200}
                src={`${host_without_last_slash}/files${avatar?.baseURL}/750x750-${avatar?.filePath}`}
              />
            ) : (
              <Image
                style={{ cursor: 'pointer' }}
                width={150}
                height={150}
                src="error"
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
              />
            )}
            {newMenu}
          </div>
          <Form>
            <Descriptions size={'middle'} column={1} bordered>
              <Descriptions.Item label={t('pupils.pupilId')}>
                {_pupil.pupilId}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.pin')}>
                {_pupil.pupil?.pin ?? pupil?.pupil?.pin ?? ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.fullName')}>
                {_pupil.pupil?.fullName ?? pupil?.pupil?.fullName ?? ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.gender')}>
                {_pupil.pupil?.gender
                  ? _pupil.pupil?.gender === 'MALE'
                    ? t('pupils.male')
                    : t('pupils.female')
                  : pupil?.pupil?.gender
                  ? pupil?.pupil?.gender === 'MALE'
                    ? t('pupils.male')
                    : t('pupils.female')
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.birthDate')}>
                {_pupil.pupil?.birthDate ?? pupil?.pupil?.birthDate ?? ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.metric')}>
                {_pupil.pupil?.metric ?? pupil?.pupil?.metric ?? ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.socialProtection')}>
                {_pupil.pupil?.socialProtection
                  ? t('general.yes')
                  : t('general.no')}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.address')}>
                {_pupil.pupil?.address
                  ? _pupil.pupil?.address
                    ? _pupil.pupil?.address !== 'NULL'
                    : ''
                  : pupil?.pupil?.address
                  ? pupil?.pupil.address !== 'NULL'
                    ? pupil.pupil.address
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.orderNo')}>
                {_pupil.orderNo
                  ? _pupil.orderNo !== 'NULL'
                    ? _pupil.orderNo
                    : ''
                  : pupil?.orderNo
                  ? pupil?.orderNo !== 'NULL'
                    ? pupil.orderNo
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.orderDate')}>
                {_pupil.orderDate
                  ? _pupil.orderDate !== 'NULL'
                    ? _pupil.orderDate
                    : ''
                  : pupil.orderDate
                  ? pupil.orderDate !== 'NULL'
                    ? pupil.orderDate
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.benefit')}>
                {_pupil.pupil?.benefit ? t('general.yes') : t('general.no')}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.benefitType')}>
                {_pupil.pupil?.benefitType
                  ? _pupil.pupil?.benefitType !== 'NULL'
                    ? _pupil.pupil?.benefitType
                    : ''
                  : pupil?.pupil?.benefitType
                  ? pupil?.pupil.benefitType !== 'NULL'
                    ? pupil.pupil.benefitType
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.applicationNo')}>
                {_pupil.pupil?.applicationNo
                  ? _pupil.pupil?.applicationNo !== 'NULL'
                    ? _pupil.pupil?.applicationNo
                    : ''
                  : pupil?.pupil?.applicationNo
                  ? pupil?.pupil.applicationNo !== 'NULL'
                    ? pupil.pupil.applicationNo
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.applicationDate')}>
                {_pupil.pupil?.applicationDate
                  ? _pupil.pupil?.applicationDate !== 'NULL'
                    ? _pupil.pupil?.applicationDate
                    : ''
                  : pupil?.pupil?.applicationDate
                  ? pupil?.pupil.applicationDate !== 'NULL'
                    ? pupil.pupil.applicationDate
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.directionDate')}>
                {_pupil.pupil?.directionDate
                  ? _pupil.pupil?.directionDate !== 'NULL'
                    ? _pupil.pupil?.directionDate
                    : ''
                  : pupil?.pupil?.directionDate
                  ? pupil?.pupil.directionDate !== 'NULL'
                    ? pupil.pupil.directionDate
                    : ''
                  : ''}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.governmentStake')}>
                {rolesChecker([AUTHORITIES.ADMIN]) ? (
                  <div style={{ display: 'inline-block' }}>
                    <Spin
                      spinning={changeGovernmentStakeLoading.value}
                      indicator={
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                          }}>
                          <ThreeDots
                            style="dot-pulse"
                            height={16}
                            padding={2}
                          />
                        </div>
                      }>
                      <Checkbox
                        onChange={toggleGovernmentStake}
                        style={{ marginRight: '10px' }}
                        checked={governmentStake}
                        name="governmentStake"
                      />
                    </Spin>
                  </div>
                ) : governmentStake ? (
                  t('general.yes')
                ) : (
                  t('general.no')
                )}
              </Descriptions.Item>
              <Descriptions.Item label={t('pupils.paymentPercentage')}>
                {rolesChecker([AUTHORITIES.ADMIN]) ? (
                  <div style={{ display: 'inline-block' }}>
                    <Spin
                      spinning={changePercentageLoading.value}
                      indicator={
                        <div
                          style={{ display: 'flex', justifyContent: 'center' }}>
                          <ThreeDots
                            style="dot-pulse"
                            height={16}
                            padding={2}
                          />
                        </div>
                      }>
                      <Radio.Group
                        name="paymentPercentage"
                        value={paymentPercentage}
                        onChange={changePaymentPercentage}
                        disabled={changePercentageLoading.value}
                        options={paymentTypes?.response?.map((i) => ({
                          value: i.id,
                          label: `${i.value}%`,
                        }))}
                      />
                    </Spin>
                  </div>
                ) : (
                  <span>
                    {_pupil?.pupil?.pupilPaymentType?.value != null
                      ? `${_pupil?.pupil?.pupilPaymentType?.value}%`
                      : ''}
                  </span>
                )}
              </Descriptions.Item>
            </Descriptions>
          </Form>
        </Card>
      ) : (
        <Loader />
      )}
    </div>
  )
}

export default OrganizationPupilInfo
